import { Experience } from '@/components/sections/experience';

export function ExperiencePage() {
  return (
    <div className="container">
      <Experience />
    </div>
  );
}